Controller.$inject = [];

function Controller() {

}

export function HuiPageSubHeader() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            isSticky: '<',
            hasTabs: '<'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return ` <div class="hui hui-sub-header" 
                          ng-class="{'is-sticky': $huiCtrl.isSticky, 'pb-0': $huiCtrl.hasTabs, 'pt-2': $huiCtrl.hasTabs}"
                          ng-transclude></div>`;
        }
    };
}